/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { StripePrice } from "./StripePrice";
import { Product } from "./Product";
export const BillingSubscriptionItem = core.serialization.object({
    price: StripePrice,
    product: Product,
    quantity: core.serialization.number(),
});
